import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=be3d616c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3d616c')) {
      api.createRecord('be3d616c', component.options)
    } else {
      api.reload('be3d616c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=be3d616c&", function () {
      api.rerender('be3d616c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/childrenage.vue"
export default component.exports